import { FC, PropsWithChildren } from 'react'

import CenterLoader from '$elements/CenterLoader'

import useSignal from '$actions/useSignal'

import { profile } from '$store/profile'

/**
 * Wait until profile data arrived.
 */
type Props = {
  preferDisplayMode?: 'loading' | 'data'
}
export const ProfileWaiter: FC<PropsWithChildren<Props>> = ({
  children,
  preferDisplayMode = 'loading'
}) => {
  const info = useSignal(profile)
  const isLoading = info?.loading
  const hasData = !!info?.data

  if (preferDisplayMode === 'data' && hasData) return children

  if (!isLoading && hasData) return children

  return <CenterLoader />
}

export default ProfileWaiter
